import { useModalStore } from "../store/useModalStore";

declare global {
  interface Window {
    onBackButton: () => void;
    closeDialogIfOpened: () => boolean;
  }
}

window.onBackButton = (): void => {
  try {
    const modal = useModalStore.getState().modals;

    if (modal.length > 0) {
      return useModalStore.getState().closeModal(modal[modal.length - 1].id);
    }
  } catch (error) {
    console.error(error, "Button Error");
  }
};

window.closeDialogIfOpened = (): boolean => {
  try {
    const modal = useModalStore.getState().modals;

    if (modal.length > 0) {
      useModalStore.getState().closeModal(modal[modal.length - 1].id);
      return true;
    }

    return false;
  } catch (error) {
    console.error(error, "Button Error");
    return false;
  }
};

export {};
